module.exports = __webpack_public_path__ + "media/state-press-2_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-2_1600.jpg
// module id = 39
// module chunks = 0